export default "__VITE_ASSET__CRrJcYGf__"